<template>
  <div :class="textClass">
    <slot name="label">
      <label v-if="hasLabel" class="rt-attr-label">{{ label }}</label>
    </slot>
    <slot>
      <span class="rt-attr-text">{{ text }}</span>
    </slot>
    <slot name="link">
      <div v-if="link" class="rt-attr-link">
        <a @click="link">详情</a>
        <rt-icon name="rt-base-arrow_right" color="#A9C2E8"></rt-icon>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'RtAttr',
  props: {
    type: {
      type: String,
      default: 'sub'
    },
    label: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    link: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    textClass() {
      return ['rt-attr', `rt-attr-${this.type}`];
    },
    hasLabel() {
      return !!this.label;
    }
  }
};
</script>

<style lang="less">
.rt-attr {
  font-size: 14px;
  color: #6388c2;
  display: flex;
  align-items: center;
  & + & {
    margin-top: 12px;
  }
  &.rt-attr-primary {
    color: #143e81;
    font-size: 16px;
  }
  .rt-attr-label {
    margin-right: 15px;
    color: #6388c2;
    font-size: 14px;
  }
  span.rt-attr-text {
    flex: 1;
    color: #143e81;
    font-size: 14px;
    // font-weight: 500;
  }
  .rt-attr-link {
    display: flex;
    align-items: center;
    line-height: 1;
    a {
      font-size: 14px;
      color: #a9c2e8;
      text-decoration: none;
      cursor: pointer;
    }
    .rt-icon {
      margin-left: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtAttr.vue?18668b7c